import { render } from "./Conversation.vue?vue&type=template&id=575951c8&scoped=true"
import script from "./Conversation.vue?vue&type=script&lang=js"
export * from "./Conversation.vue?vue&type=script&lang=js"

import "./Conversation.vue?vue&type=style&index=0&id=575951c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575951c8"]])

export default __exports__